import { IGeneralRedux } from "../../../common/models/response";

export interface ISettingReduxState extends IGeneralRedux {}

export const settingState: ISettingReduxState = {
  actionsLoading: false,
  listLoading: false,
  searchLoading: false,
};
